export const UNICODE_LOCKER = '\uD83D\uDD12';
export const UNICODE_NBSP = '\u00A0';
export const UNICODE_DASH = '\u2011';
